'use strict';

const React = require('react');
const Teaser = require('./Teaser');
const HeroTeaserArea = ({model}) => {
	if (!model) { return <noscript/>; }
	return (
		<div className="svtse_hero-teaser-area">
			<Teaser model={model} teaserArea="hero" imageType="extralarge_imax" layout="type1" />
		</div>
	);
};

HeroTeaserArea.propTypes = {
	model: React.PropTypes.object
};

module.exports = HeroTeaserArea;



/** WEBPACK FOOTER **
 ** ./app/components/Teaser/HeroTeaserArea.jsx
 **/